import { Drawer, Grid, Tooltip } from "antd"
import React from "react"
import { FileViewerCached } from "~Components/fileViewer/FileViewerCached"
import { onCloseDrawer } from "./drawer.utils"

const { useBreakpoint } = Grid

interface FileViewerDrawerProps {
    open: boolean
    onClose: () => void
    filePath: string
    fileName: string
}

export const FileViewerDrawer = ({ open, onClose, filePath, fileName }: FileViewerDrawerProps) => {
    const screens = useBreakpoint()

    return (
        <Drawer
            open={open}
            title={
                <Tooltip title={fileName} placement="bottom">
                    <span className="truncate block max-w-300">{fileName}</span>
                </Tooltip>
            }
            footer={undefined}
            destroyOnClose={true}
            placement="right"
            closable={true}
            width={screens.xxl ? "1500px" : "800px"}
            data-testid="finway:fileViewer:drawer"
            onClose={onCloseDrawer(onClose)}
        >
            <FileViewerCached filePath={filePath} />
        </Drawer>
    )
}
